<template>
  <span
    v-if="isTruncate"
    v-tooltip="`${value}`"
    class="block max-w-[120px] truncate"
    >{{ value || "-" }}</span
  >
  <span v-else>{{ value || "-" }}</span>
</template>

<script>
export default {
  name: "FallbackText",
  props: {
    value: String,
    isTruncate: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
